// extracted by mini-css-extract-plugin
export default {"marker":"style_marker__CQ4Dg","container":"style_container__ht7Wk","title":"style_title__7ZYvs"};